import axios from 'api/axios'

export interface ActiveSignalsClient {
	id: string
	name: string
	email?: string | null
	mobileDisplay?: string | null
	waBusinessConnected?: boolean
	waBusinessPhone?: string | null
	signalsAppConnected?: boolean
	signalsAppLastSeenAt?: string | null
}

/**
 * List active Signals users for a client (super-admin dashboard).
 * Uses management session — not the CRM client-scoped active-clients route.
 */
const getActiveSignalsClients = async (
	clientId: string
): Promise<ActiveSignalsClient[]> => {
	const { data } = await axios.get<ActiveSignalsClient[]>(
		`api/signals/active-clients/by-client?clientId=${encodeURIComponent(
			clientId
		)}`
	)
	return data
}

export default getActiveSignalsClients
